'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'

import { ProductSearchResultInfoDialog } from './ProductSearchResultInfoDialog'

export const ProductSearchResultInfoIconButton: FC = () => {
  const modalControls = useOpenableControls()
  const { tenant } = useGlobalConfigContext()
  const intl = useIntl()

  if (![TENANT.AT, TENANT.COM].includes(tenant)) {
    return null
  }

  return (
    <>
      <button
        aria-label={intl.formatMessage({
          id: 'searchResults.label.infoHeader',
        })}
        className="text-dark-primary-strong"
        data-qa-id="form-search-info"
        name="search-info"
        onClick={modalControls.handleOpen}
        type="button"
      >
        <IconInfo className="ml-1 inline-block size-5 shrink-0 align-top" />
      </button>
      <ProductSearchResultInfoDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
